import {
    FacebookShareButton,
    TwitterShareButton,
    EmailShareButton,
    FacebookIcon,
    XIcon,
    LinkedinShareButton, LinkedinIcon, EmailIcon
} from 'react-share';
import Parser from "html-react-parser";


const Social = ({ url, title, description }) => {
    const parsedTitle = title ? Parser(title) : '';
    const parsedDescription = description ? Parser(description) : '';

    return (
          <div className="social-links" style={{gap: '5px'}}>
            <FacebookShareButton
                url={url}
                title={parsedTitle}
                description={parsedDescription}
                aria-label="Facebook">
                <FacebookIcon size={32} round />
            </FacebookShareButton>

            <TwitterShareButton
                url={url}
                title={parsedTitle}
                description={parsedDescription}
                aria-label="Twitter">
                <XIcon size={32} round />
            </TwitterShareButton>

              <LinkedinShareButton
                  url={url}
                  title={parsedTitle}
                  description={parsedDescription}
                  aria-label="Linkedin">
                  <LinkedinIcon size={32} round />
              </LinkedinShareButton>

              <EmailShareButton
                      url={url}
                      subject={parsedTitle}
                      description={parsedDescription}
                      body="body"
                      className="Demo__some-network__share-button"
                      aria-label="Email Share">
                  <EmailIcon size={32} round />
              </EmailShareButton>
          </div>
  );
};

export default Social;
